// extracted by mini-css-extract-plugin
export default {"border":"SoldDateDisclaimer_border__EunT5","iconWrapper":"SoldDateDisclaimer_iconWrapper__kenC4"};